<template>
<!--    <g>-->
        <path ref="path" :id="country.id" :d="country.d" :class="{'has-data': country.data}" @click="onClick">
        </path>
<!--    </g>-->
</template>

<script>
    export default {
        name: "BrandsMapCountry",
        props: {
            country: {
                type: Object,
                required: true
            }
        },
        data () {
            return {
                pinWidth: 50
            }
        },
        mounted() {
            if (this.country.data) {

                const offset = this.country.pinOffset ? this.country.pinOffset : null;
                let offsetX = 0;
                let offsetY = 0;

                if (offset && offset.x) offsetX = offset.x;
                if (offset && offset.y) offsetY = offset.y;

                const pinPosition = {
                    left: offsetX,
                    top: offsetY
                };

                this.$emit('create-pin', {
                    ...pinPosition,
                    country: this.country.id
                })
            }
        },
        methods: {
            onClick() {
                if (!this.country.data) return;
                this.$emit('click', {
                    country: this.country,
                    bounds: this.$refs.path.getBoundingClientRect()
                });
            }
        }
    }
</script>
